import { CompanyHero } from '@/components/company/CompanyHero';
import { LarkinLegacy } from '@/components/company/LarkinLegacy';
import { TimelineOfIntegrity } from '@/components/company/TimelineOfIntegrity';
import { FortyYearProblem } from '@/components/company/FortyYearProblem';
import { CategoryDefinition } from '@/components/company/CategoryDefinition';
import { IntegrityValues } from '@/components/company/IntegrityValues';
import { TrustBar } from '@/components/company/TrustBar';
import { FutureOfSurgicalFinance } from '@/components/company/FutureOfSurgicalFinance';
import { CompanyCTA } from '@/components/company/CompanyCTA';

const Company = () => {
  return (
    <>
      <CompanyHero />
      <LarkinLegacy />
      <TimelineOfIntegrity />
      <FortyYearProblem />
      <CategoryDefinition />
      <IntegrityValues />
      <TrustBar />
      <FutureOfSurgicalFinance />
      <CompanyCTA />
    </>
  );
};

export default Company;
